import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledZonesContainer = styled(Stack)(({ theme }) => ({
	flexDirection: 'row',
	alignItems: 'center',
	flexWrap: 'wrap',
	gap: theme.spacing(1),
	paddingTop: theme.spacing(1),
}));
